module.exports = __webpack_public_path__ + "static/media/opensans-semibold.04a5614c.woff2";